import { Grid } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { useParams } from 'react-router-dom';
import { getFundraiserById } from 'src/shared/services/fundraiserService';
import { FundraiserResponse } from '../models/fundraiserResponse';
import { FundraiserTotalsSummary } from '../components/fundraiserTotalsSummary';
import { FundraiserDateRangePicker } from '../components/fundraiserDateRangePicker';

export const FundraiserDetailPage = () => {
  const isMounted = useIsMounted();
  const params = useParams();

  const [, setLoadingFundraiser] = useState<boolean>(false);
  const [fundraiser, setFundraiser] = useState<FundraiserResponse>();

  const fetchData = useCallback(async () => {
    setLoadingFundraiser(true);

    try {
      const res = await getFundraiserById(params.id);
      if (isMounted()) {
        setFundraiser(res.data);
      }
    } catch (e) {
      ConsoleHelper.log(e);
    } finally {
      setLoadingFundraiser(false);
    }
  }, [isMounted, params.id]);

  useEffect(() => {
    if (params.id) {
      fetchData();
    }
  }, [fetchData, params.id]);

  return (
    <Grid container spacing={3}>
      <Grid
        item
        xs={6}
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <MainContentHeader title={fundraiser?.heading || ''} />
      </Grid>

      <Grid item xs={12} mt={-1}>
        <Grid container spacing={3}>
          <Grid item xs={12} xl={11} display='flex' flexDirection='column'>
            <FundraiserTotalsSummary fundraiser={fundraiser} />
          </Grid>

          <Grid item xs={12} xl={11} display='flex' flexDirection='column'>
            <FundraiserDateRangePicker fundraiserId={fundraiser?.fundraiser_id || 0} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
